import { BRAND, type ColorMode } from '@chukua/common';
import type { LayerSpecification } from 'maplibre-gl';

export const TRIP_TRACK_SOURCE_ID = 'trip-track';
/** The zones overlay goes under this layer so the route stays on top of the places. */
export const TRIP_TRACK_LINE_LAYER_ID = 'trip-track-line';

/** Fonts the MapTiler streets style serves glyphs for; a symbol layer naming any other draws no text. */
const LABEL_FONT = ['Roboto Medium', 'Noto Sans Regular'];

/** The route as a line, the truck as a dot, and an arrow on it when the newest fix has a heading. */
export function tripTrackLayers(mode: ColorMode): LayerSpecification[] {
  const palette = BRAND.palettes[mode];
  return [
    {
      id: TRIP_TRACK_LINE_LAYER_ID,
      type: 'line',
      source: TRIP_TRACK_SOURCE_ID,
      filter: ['all', ['==', ['get', 'kind'], 'track'], ['==', ['get', 'source'], 'gps']],
      layout: { 'line-cap': 'round', 'line-join': 'round' },
      paint: { 'line-color': palette.primary, 'line-width': 3, 'line-opacity': 0.8 },
    },
    {
      id: 'trip-track-phone-line',
      type: 'line',
      source: TRIP_TRACK_SOURCE_ID,
      filter: ['all', ['==', ['get', 'kind'], 'track'], ['==', ['get', 'source'], 'phone']],
      layout: { 'line-join': 'round' },
      paint: { 'line-color': palette.accent, 'line-width': 3, 'line-opacity': 0.9, 'line-dasharray': [2, 2] },
    },
    {
      id: 'trip-track-stops',
      type: 'circle',
      source: TRIP_TRACK_SOURCE_ID,
      filter: ['==', ['get', 'kind'], 'stop'],
      paint: { 'circle-radius': 6, 'circle-color': palette.surface, 'circle-stroke-color': palette.warning, 'circle-stroke-width': 3 },
    },
    {
      id: 'trip-track-stop-names',
      type: 'symbol',
      source: TRIP_TRACK_SOURCE_ID,
      filter: ['==', ['get', 'kind'], 'stop'],
      layout: { 'text-field': ['get', 'name'], 'text-font': LABEL_FONT, 'text-size': 11, 'text-offset': [0, 1.2], 'text-anchor': 'top' },
      paint: { 'text-color': palette.text, 'text-halo-color': palette.surface, 'text-halo-width': 1.5 },
    },
    {
      id: 'trip-track-truck',
      type: 'circle',
      source: TRIP_TRACK_SOURCE_ID,
      filter: ['==', ['get', 'kind'], 'truck'],
      paint: { 'circle-radius': 8, 'circle-color': palette.success, 'circle-stroke-color': palette.surface, 'circle-stroke-width': 2 },
    },
    {
      id: 'trip-track-heading',
      type: 'symbol',
      source: TRIP_TRACK_SOURCE_ID,
      filter: ['all', ['==', ['get', 'kind'], 'truck'], ['get', 'hasHeading']],
      layout: {
        'text-field': '▲',
        'text-font': LABEL_FONT,
        'text-size': 9,
        'text-rotate': ['get', 'heading'],
        'text-rotation-alignment': 'map',
        'text-allow-overlap': true,
        'text-ignore-placement': true,
      },
      paint: { 'text-color': palette.surface },
    },
  ];
}
